function calculateLiquid() {
  const total = parseFloat(document.getElementById('totalVolume').value);
  const aroma = parseFloat(document.getElementById('aromaMl').value);
  const shotStrength = parseFloat(document.getElementById('shotStrength').value);
  const desired = parseFloat(document.getElementById('desiredStrength').value);

  if (isNaN(total) || isNaN(aroma) || isNaN(shotStrength) || isNaN(desired)) {
    document.getElementById('result').innerHTML = 'Bitte alle Felder korrekt ausfüllen.';
    return;
  }

  const requiredNicotineMg = total * desired;
  const shotAmount = requiredNicotineMg / shotStrength;

  const shotRounded = Math.round(shotAmount / 10) * 10;
  const shotsCount = shotRounded / 10;

  const base = total - aroma - shotRounded;

  document.getElementById('result').innerHTML = `
    Aroma: ${aroma.toFixed(2)} ml<br>
    Nikotinshot: ${shotRounded.toFixed(0)} ml (≈ ${shotsCount} Shot)<br>
    Nikotinfreie Base: ${base.toFixed(2)} ml
  `;

  document.getElementById('result').scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
}
